import { IAppState } from '../../../types/redux';

import { selectExperiments } from '../../selectExperiments';
import { isAbUseExperimentGroup } from '../../../utils/isAbUseExperimentGroup';

// TODO: Удалить эксперимент в CD-243912.
export const NEWBUILDING_BROKER_SELF_REQUEST_FORM = 'newbuilding_booking_independent_application_desktop';

export const selectNewbuildingBrokerSelfRequestFormExperimentEnabled = (state: IAppState): boolean => {
  const abUseExperiments = selectExperiments(state);

  return isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_BROKER_SELF_REQUEST_FORM, 'B');
};
